"use client";
import HomeLayout from "../components/homepage/HomeLayout";
import React from "react";
import LABELS from "@/components/global-constant/src/general";

export default function HomePage() {
  const layoutData = [
    {
      id: 2,
      component: 2,
    },

    { id: 5, component: 5 },
    { id: 3, component: 3 },
    { id: 14, component: 14 },

    {
      id: 4,
      component: 4,
    },
    { id: 6, component: 6 },
    { id: 7, component: 7 },
    {
      id: 8,
      component: 10,
    },
    { id: 9, component: 9 },

    { id: 11, component: 11 },
    { id: 12, component: 12 },
  ];

  const jsonLd = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": LABELS.ORGANIZATION.NAME,
    "logo": LABELS.ORGANIZATION.LOGO,
    "url": LABELS.ORGANIZATION.URL,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <section className="w-full mx-auto">
        <HomeLayout layoutData={layoutData} />
      </section>
    </>
  );
}
